module.exports = __webpack_public_path__ + "img/monitorbox28.ed89ed07.jpg";